import React, { useEffect, useState } from "react";
import curorx_re_site_logo from "../../../assets/images/CuroRX_RE_SiteLogo.gif";
import { useNavigate, Link } from "react-router-dom";
import { handleAuth, getPharmacyById } from "../../../services/Common";
import { User, Pharmacy } from "../../../utils/globalState";
import { handleGetPharmacies } from "../../../services/Admin";
import { useAuth0 } from "@auth0/auth0-react";
import { appsUrls } from "../../../utils/baseURL";
import AppSelection from "../../../pages/common/AppSelection";

// Spinner Component
const FullPageSpinner = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const Login = () => {
  const {
    isAuthenticated,
    loginWithRedirect,
    user,
    getAccessTokenSilently,
    isLoading,
    logout,
  } = useAuth0();
  const { setUser } = User();
  const navigate = useNavigate();
  const { sales, ai } = appsUrls;

  // State
  const [errorMsg, setErrorMsg] = useState("");
  const [hasRun, setHasRun] = useState(false);
  const [showAppSelection, setShowAppSelection] = useState(false);
  const [appAccess, setAppAccess] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [fetchingData, setFetchingData] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const redirect = urlParams.get("redirect");

  const fetchToken = async () => await getAccessTokenSilently();
  useEffect(() => {
    const runAuthFlow = async () => {
      let token = await fetchToken();
      if (redirect) {
        sessionStorage.setItem("rdr", redirect);
      }
      if (!isAuthenticated || !user || hasRun) {
        

        if (!token) {
          navigate("/");
        }
      }
      setHasRun(true);

      try {
        setFetchingData(true);
        if (token) localStorage.setItem("Token", token);
        console.log(user);
        let payload = { email: "" };
        if (user) {
          payload = { email: user.email };
        }

        if (payload.email === "") {
          setErrorMsg("No user email found. Please log in again.");
          return;
        }
        const data = await handleAuth(payload)
          .then((resp) => resp.data)
          .catch((err) => {
            console.error("Auth error:", err);
            return { user_type: "" };
          });

        setFetchingData(false);
        data.auth0User = user;
        setUser(data);
        setUserInfo(data);

        const metadata = data.auth0User.user_metadata || {};
        const apps = Array.isArray(metadata.app_access)
          ? metadata.app_access
          : [];

        const { user_type, pharmacyID, first, last, Role: role } = data;

        localStorage.setItem("first", first);
        localStorage.setItem("last", last);
        localStorage.setItem("role", role);
        localStorage.setItem("pharmacy", pharmacyID);

        if (apps.length > 1) {
          const storedRedirect = sessionStorage.getItem("rdr") || "";

          if ((redirect || storedRedirect.trim()) && apps.includes("curorx")) {
            setShowAppSelection(false);
            handleAppSelection("curorx", data);
            sessionStorage.setItem("rdr", redirect);
          } else {
            setAppAccess(apps);
            setShowAppSelection(true);
            // sessionStorage.setItem("rdr", "curorx");
          }
        } else if (apps.length === 1) {
          handleAppSelection(apps[0], data);
        } else {
          console.error("User has no app_access defined in Auth0 metadata");
          logout({
            logoutParams: {
              returnTo: window.location.origin,
              federated: true,
            },
          });
          localStorage.clear();
          sessionStorage.clear();
        }
        if (user_type) {
          setTimeout(() => {
            if (user_type.toLowerCase() !== "admin") {
              getPharmacyById(pharmacyID)
                .then((pharmacyResp) =>
                  localStorage.setItem("pharmacyName", pharmacyResp.data.name)
                )
                .catch((err) => console.error("Pharmacy fetch error:", err));
            }

            handleGetPharmacies(pharmacyID)
              .then((phResp) =>
                Pharmacy.setState({
                  info: phResp.data.data.find((p) => p.id === pharmacyID),
                })
              )
              .catch((err) => console.error("Pharmacy list fetch error:", err));
          }, 100); // Give a slight delay to let navigation happen first
        }
      } catch (err) {
        console.error("Login flow error:", err);
        setErrorMsg("Invalid credentials. Please try again.");
        setFetchingData(false);
      }
    };

    runAuthFlow();
  }, [isAuthenticated, isLoading]);

  const handleAppSelection = (app, userObj = userInfo) => {
    window.sessionStorage.setItem("rdr", redirect || "curorx");
    setFetchingData(true);
    const userType = userObj?.user_type?.toLowerCase() || "";
    if (app === "curorx") {
      if (userType) {
        switch (userType) {
          case "user":
            navigate("/pharmacy-user/dashboard");
            break;
          case "pharmacyadmin":
            navigate("/pharmacy-admin/dashboard");
            break;
          case "admin":
            navigate("/admin/managePharmacy");
            break;
          case "provider":
            navigate("/provider/dashboard");
            break;
          case "patient":
            userObj.active
              ? navigate("/patient/homepage")
              : setErrorMsg("User is not active. Please contact admin.");
            break;
          default:
            navigate("/");
        }
      } else {
        console.error("User type is not defined:", userType);
        navigate("notAuthorized");
        return;
      }
    } else if (app === "sales") {
      window.location.href = `${sales.url}?redirect=curorx`;
    } else if (app === "ai") {
      window.location.href = `${ai.url}?redirect=curorx`;
    } else {
      console.error("Unknown app:", app);
      logout({ returnTo: window.location.origin });
    }
    setShowAppSelection(false);
    setFetchingData(false);
  };

  if (
    isLoading ||
    fetchingData ||
    redirect?.trim() ||
    sessionStorage.getItem("rdr")
  ) {
    if (appAccess.length > 1 && !appAccess.includes("curorx")) {
      return (
        <AppSelection appAccess={appAccess} onSelect={handleAppSelection} />
      );
    } else if (appAccess.length === 1) {
      handleAppSelection(appAccess[0]);
      return null; // Redirect will happen in handleAppSelection
    }
    return <FullPageSpinner />; // Auth0 still initializing
  }

  if (showAppSelection)
    return <AppSelection appAccess={appAccess} onSelect={handleAppSelection} />;


  return (
    <div className="container-fluid" id="index-top-logo-login-div">
      <div className="row g-0 align-items-center">
        <div className="col-md-6">
          <img
            src={curorx_re_site_logo}
            className="img-fluid"
            id="curo-re-logo"
            alt="Welcome to CuroRX"
          />
        </div>
        <div className="col-md-6 text-end" id="top-login-div" />
      </div>

      <div id="index-welcome-div" className="text-start">
        <div id="index-welcome-div-login">
          <h1 className="fs-1" id="index-welcome-div-h1">
            Welcome to <span className="curo">Curo</span>
            <span className="rx">RX</span>
          </h1>
          <p id="index-welcome-div-p">
            The all-in-one patient management platform designed with you in
            mind.
          </p>

          <form className="d-flex flex-column align-items-start my-5">
            {errorMsg && (
              <div className="col-12 text-danger mb-3">{errorMsg}</div>
            )}
            <div className=" justify-content-start gap-3 col-12 col-md-10 col-lg-8">
              <div className="d-flex flex-column flex-sm-row gap-2">
                <button
                  className="curo_btn_primary col-12 col-sm-6 col-lg-4 my-3"
                  type="button"
                  onClick={() => loginWithRedirect()}
                >
                  Login
                </button>
              </div>
              {/* <div className="register-links d-flex flex-column text-start">
                <Link to="/register">REGISTER</Link>
                <Link to="/resetpassword">FORGOT YOUR PASSWORD?</Link>
              </div> */}
            </div>
          </form>
        </div>
      </div>

      <div id="four-tiles-div" className="row text-center g-4">
        <div className="col-12 col-sm-6 col-lg-3" id="tile-send-new-referral">
          <i className="fas fa-file-prescription" id="icon-send-new-referral" />
          <p id="tile-text-send-new-referral">
            SEND A NEW <strong>REFERRAL</strong>
          </p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3" id="tile-new-patient">
          <i className="fas fa-user-plus" id="icon-new-patient-registration" />
          <p id="tile-text-new-patient-registration">
            NEW PATIENT <strong>REGISTRATION</strong>
          </p>
        </div>
        <div
          className="col-12 col-sm-6 col-lg-3"
          id="tile-register-as-new-provider"
        >
          <i className="fas fa-user-md" id="icon-register-as-new-provider" />
          <p id="tile-text-register-as-new-provider">
            NEW PROVIDER <strong>REGISTRATION</strong>
          </p>
        </div>
        <div className="col-12 col-sm-6 col-lg-3" id="tile-training-resources">
          <i className="fas fa-envelope" id="icon-training-resources" />
          <p id="tile-text-training-resources">
            SEND/RECEIVE <strong>MESSAGES</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
